import React, { useState } from 'react'
import { FaTelegramPlane, FaTwitter, FaInstagramSquare, FaYoutube } from "react-icons/fa";

import { IoLogoBehance } from "react-icons/io5";
import { IoLogoBuffer, IoLogoPolymer, IoLogoVk } from "react-icons/io";
const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const countryList = [
    { icons: <IoLogoBuffer size={25} />, countryName: "Itali" },
    { icons: <IoLogoBehance size={25} />, countryName: "India" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Usa" },
    { icons: <IoLogoVk size={25} />, countryName: "Rusia" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Bangladesh" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Pakisthan" },
    { icons: <IoLogoBehance size={25} />, countryName: "America" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Chaina" }
  ]

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className='bg-[#333435] w-full   md:py-2 lg:py-2 py-5 px-4   md:mx-auto' >
        <div className='md:flex md:justify-center md:items-center py-6  '>
          <div className=' md:block  md:justify-around grid grid-rows-2  md:items-center text-white gap-8 fl'>
           
            <div className='flex items-center mx-auto gap-8'>
              <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaTelegramPlane /></p>
              <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaTwitter /></p>
              <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaInstagramSquare /></p>
              <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaYoutube /></p>
            </div>
            <div className='text-gray-400 text-center md:text-start py-6'>
              <p>Disclaimer © 2024 All Rights Reserved</p>
              {/* <p>Disclaimer</p> */}
            </div>
          </div>
          {/* <div className='md:flex hidden z-20'>
            <div className=' '>
              <div className="p-10">
                <div className="dropdown hidden md:inline-block relative">
                  <button className="bg-gray-300  text-gray-700 font-semibold py-2 px-4 rounded inline-flex items-center" onClick={toggleDropdown}>
                    <span className=" flex gap-2 mr-8"><span><IoLogoBuffer size={25} /></span> English</span>
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                  </button>
                  {isOpen && (
                    <ul className="dropdown-menu absolute text-gray-700 pt-1">
                      {
                        countryList.map((item, index) => (
                          <li key={index} className='flex text-slate-500 items-center gap-5  bg-[#333]
                          hover:bg-gray-500 hover:text-slate-50  my-2 py-2 px-4  whitespace-no-wrap'> <span className='text-white'>{item.icons}</span><p className=""
                            >{item.countryName}</p>
                            <hr />
                          </li>
                        ))
                      }
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default Footer